import React, { ReactNode } from 'react';
import { CounterElement, Element } from './MaxLengthConter.styles';

export interface MaxLengthConterProps {
  className?: string;
  children?: ReactNode;
  counter?: number;
}

const MaxLengthConter = ({ children, counter, ...props }: MaxLengthConterProps) => {
  return (
    <Element>
      {children}
      <CounterElement>{counter}</CounterElement>
    </Element>
  );
};

export default MaxLengthConter;
